import { ConfigEntry } from '../services/config.service';

/**
 * Holiday care configuration entries
 * All configurations related to holiday care registration deadlines and restrictions
 *
 * ⚠️ When changing default values, update the following docs:
 *   - docs/customer/ferienbetreuung-buchen.md
 *   - docs/customer/faq.md
 *   - docs/employee/admin-aktionen.md
 *   - docs/employee/ferienbetreuung-verwaltung.md
 *   - docs/employee/faq.md
 */
export const HOLIDAY_CARE_CONFIG: ConfigEntry[] = [
  {
    key: 'DEADLINE_CHECKS_ENABLED',
    value: true,
    description:
      'Aktiviert/deaktiviert alle Anmeldeschluss-Prüfungen für die Ferienbetreuung',
    searchTags: ['anmeldeschluss', 'prüfungen', 'aktiviert', 'schalter'],
    group: 'holiday_care',
    type: 'boolean',
    defaultValue: true,
  },
  {
    key: 'DEFAULT_REGISTRATION_DEADLINE_WEEKS',
    value: 6,
    description: 'Standard-Anmeldefrist in Wochen vor Ferienbeginn',
    searchTags: ['anmeldefrist', 'standard', 'wochen', 'ferienbeginn'],
    group: 'holiday_care',
    type: 'number',
    defaultValue: 6,
  },
  {
    key: 'CANCELLATION_DEADLINE_WEEKS',
    value: 6,
    description:
      'Stornofrist in Wochen vor Ferienbeginn für kostenfreie Abmeldung',
    searchTags: ['storno', 'abmeldung', 'frist', 'wochen'],
    group: 'holiday_care',
    type: 'number',
    defaultValue: 6,
  },
  {
    key: 'CONTRACT_DURATION_YEARS',
    value: 1,
    description:
      'Standard-Vertragslaufzeit in Jahren (Verträge laufen bis 31. Juli + X Jahre ab Startdatum)',
    searchTags: ['vertrag', 'laufzeit', 'jahre', 'dauer'],
    group: 'holiday_care',
    type: 'number',
    defaultValue: 1,
  },
];

/**
 * Holiday care group metadata
 */
export const HOLIDAY_CARE_GROUP_NAME = 'Ferienbetreuung';
export const HOLIDAY_CARE_GROUP_DESCRIPTION =
  'Anmeldeschlüsse und Beschränkungen für die Ferienbetreuung';
